import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import scrollToElement from 'scroll-to-element';

class ScrollPageToHereNow extends PureComponent {
  componentDidMount() {
    this._scrollPageToNode();
  }

  componentDidUpdate() {
    this._scrollPageToNode();
  }

  _scrollPageToNode() {
    if (! this.node) return;
    scrollToElement(this.node, {
      offset: this.props.offset,
      ease: 'in-out-quad',
    });
  }

  render() {
    return <div ref={(ref) => {
      this.node = ref;
    }} />;
  }
}

ScrollPageToHereNow.propTypes = {
  offset: PropTypes.number,
};

ScrollPageToHereNow.defaultProps = {
  offset: 0,
};

export default ScrollPageToHereNow;



// WEBPACK FOOTER //
// ./components/ScrollPageToHereNow/index.jsx